import { computed } from 'vue';
import { useAppState } from '@/composables/useAppState';
export function useEmployer() {
    const state = useAppState();
    const isMoneyGuided = computed(() => state.employer?.name === 'Money Guided');
    return { isMoneyGuided };
}
